import React, { FC, useEffect } from "react";
import { Redirect, RouteProps } from "react-router-dom";
import { isAllowedFlag } from "../components/feature-flag/feature-flags";
import { useFeatureFlags } from "../components/feature-flag/use-feature-flags";
import { AvailableFeaturesFlags } from "../models/feature-flag";
import { availableRoutes } from "./routes";

type Props = {
  allowedFlags: AvailableFeaturesFlags[];
  redirectUrl: string;
} & RouteProps;

export const FFRoute: FC<Props> = props => {
  const { isLoading, featuresFlags } = useFeatureFlags();
  const { redirectUrl, allowedFlags } = props;
  useEffect(() => {
    if (isLoading === false && !isAllowedFlag(allowedFlags, featuresFlags)) {
      window.location.assign(props?.location?.pathname || availableRoutes.default);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, featuresFlags]);

  if (isLoading === false && isAllowedFlag(allowedFlags, featuresFlags)) {
    return <Redirect to={redirectUrl} />;
  }

  return null;
};
